// functions/range.ts
import "../validator.js";
import { ValidationError } from "../errors/ValidationError.js";
var min = (min2, translationKey = "validation_too_low") => (options) => {
  if (options.value === void 0 || options.value === null)
    return;
  if (options.value < min2)
    throw new ValidationError(`Value of ${options.key} has to be at least ${min2}`, {
      key: options.key,
      translationKey
    });
};
var max = (max2, translationKey = "validation_too_large") => (options) => {
  if (options.value === void 0 || options.value === null)
    return;
  if (options.value > max2)
    throw new ValidationError(`Value of ${options.key} has to be smaller than ${max2 + 1}`, {
      key: options.key,
      translationKey
    });
};
export {
  max,
  min
};
